import { ReportAiSummary } from '../../../Api/Report/reportApi';
import { formatGeneratedAt } from '../../../utils/summaryDate';
import { TextBlock } from '../../Atoms/Text';
import { PageCard } from '../../Compounds/CardWithTitle';

export interface ReportExecutiveSummaryProps {
  summary: ReportAiSummary;
}

export const ReportExecutiveSummary = ({ summary }: ReportExecutiveSummaryProps) => {
  const generatedAt = formatGeneratedAt(summary.generatedAt, 'MMMM d, yyyy');

  return (
    <PageCard
      title="Executive Summary"
      dataCy="report-executive-summary"
      enableCollapse
      collapsed={false}>
      <>
        {generatedAt && (
          <TextBlock
            size="xs"
            color="grey8"
            className="mb-2">
            Generated {generatedAt}
          </TextBlock>
        )}
        <TextBlock
          size="sm14"
          color="grey10"
          className="whitespace-pre-line"
          dataTestId="report-executive-summary-text">
          {summary.summaryText}
        </TextBlock>
      </>
    </PageCard>
  );
};
